import React, { useState, useEffect } from "react";
import { Row, Col, Divider, Form, Card } from "antd";
import {
  BankOutlined,
  CloseOutlined,
  CreditCardOutlined,
  DollarCircleOutlined,
  GiftOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import { formatNumber } from "../../../../store/utils/format_number/format_number";
import IncomeCash from "./income_cash";
import IncomeEftPos from "./income_eftpos";
import IncomeGift from "./income_gift";
import IncomeBank from "./income_bank";

const IncomeReceivable = ({ edit, total, setTotal }) => {
  // -------------------------- VAR --------------------------
  const form = Form.useFormInstance();
  const cashUp = form.getFieldValue();
  // -------------------------- STATE --------------------------

  const [cash, setCash] = useState(0);
  const [eftpos, setEftPos] = useState(0);
  const [gift, setGift] = useState(0);
  const [bank, setBank] = useState(0);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (cashUp) {
      const cash = cashUp?.cash;
      const eftpos = cashUp?.eftpos;
      const gift = cashUp?.gift;
      const bank = cashUp?.bankTransfer;
      setCash(cash);
      setEftPos(eftpos);
      setGift(gift);
      setBank(bank);
    }
  }, [cashUp]);

  useEffect(() => {
    const total = cash + eftpos + gift + bank;
    setTotal(total);
  }, [cash, eftpos, gift, bank]);
  // -------------------------- RENDER --------------------------
  const renderTotal = () => {
    const labelTotal = formatNumber(total);
    return labelTotal;
  };

  const renderList = () => {
    return (
      <Row style={{ margin: "5px 0px" }}>
        {renderEft()}
        {renderCash()}
        {renderGiftCard()}
        {renderBankTransfer()}
      </Row>
    );
  };

  const renderCash = () => {
    return (
      <Row className="justify-item">
        <Col className="justify-item" span={16} align="left">
          <DollarCircleOutlined
            style={{ fontSize: 24, color: "green", marginRight: 10 }}
          />
          Cash
        </Col>
        <Col className="justify-item" span={8} align="right">
          <IncomeCash edit={edit} cash={cash} setCash={setCash} />
        </Col>
      </Row>
    );
  };

  const renderEft = () => {
    return (
      <Row className="justify-item">
        <Col className="justify-item" span={16} align="left">
          <CreditCardOutlined
            style={{ fontSize: 24, color: "blue", marginRight: 10 }}
          />
          EFTPOS
        </Col>
        <Col className="justify-item" span={8} align="right">
          <IncomeEftPos edit={edit} eftpos={eftpos} setEftPos={setEftPos} />
        </Col>
      </Row>
    );
  };

  const renderGiftCard = () => {
    return (
      <Row className="justify-item">
        <Col className="justify-item" span={16} align="left">
          <GiftOutlined
            style={{ fontSize: 24, color: "red", marginRight: 10 }}
          />
          Westfield Gift Card
        </Col>
        <Col className="justify-item" span={8} align="right">
          <IncomeGift edit={edit} gift={gift} setGift={setGift} />
        </Col>
      </Row>
    );
  };

  const renderBankTransfer = () => {
    return (
      <Row className="justify-item">
        <Col className="justify-item" span={16} align="left">
          <BankOutlined
            style={{ fontSize: 24, color: "black", marginRight: 10 }}
          />
          Bank Transfer
        </Col>
        <Col className="justify-item" span={8} align="right">
          <IncomeBank edit={edit} bank={bank} setBank={setBank} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Income Receivables:</Col>
      <Col align="right" span={10}>
        ${renderTotal()}
      </Col>
    </Row>
  );
  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="item-card" title={title}>
          <Col span={24}>{renderList()}</Col>
        </Card>
      </Col>
    </Row>
  );
};

export default IncomeReceivable;
